
import * as Sentry from '@sentry/browser';
import { BrowserOptions } from '@sentry/browser/types/client';

function initializeSentry (): void {
    const sentryInfo = document.querySelector<HTMLDivElement>('#sentry');
    if (sentryInfo !== null) {
        const sentryOptions: BrowserOptions = {
            dsn: sentryInfo.dataset['dsn'],

            environment: sentryInfo.dataset['environment'] ?? 'production',

            integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],

            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            // We recommend adjusting this value in production
            tracesSampleRate: 0.2,
            replaysOnErrorSampleRate: 1.0,
        };

        if (sentryInfo.dataset['release']) {
            sentryOptions['release'] = sentryInfo.dataset['release'];
        }
        // TODO make this lazy
        Sentry.init(sentryOptions);
    } else {
        // eslint-disable-next-line no-console
        console.warn('Not initializing Sentry');
    }
}

const stateCheck = setInterval((): void => {
    if (document.readyState === 'interactive') {
        clearInterval(stateCheck);

        initializeSentry();
    }
}, 100);
